<script setup>
import { defineComponent, onMounted, ref, useTemplateRef } from 'vue'
import { loadPayline } from '@/payline-helper.js'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'

defineComponent({
  name: 'Rechargement',
})

const props = defineProps({
  modeDepositaire: {
    type: Boolean,
    default: false,
  },
})

// Commun
const titres = ref([])
const numeroRechargement = ref(null)
const needFacture = ref(false)
const email = ref(null)
const suiteForm = ref(false)
const paymentToken = ref(undefined)
const isAchatCollapsed = ref(false)
const isPaiementCollapsed = ref(true)
const loadingTitre = ref(false)
const loading = ref(false)
const loadingErreur = ref(false)
const erreurMessage = ref(null)
const titreSelectionne = ref('')
const justificatifProduitFile = ref(null)
const justificatifValidationMessage = ref('')
let numeroRechargementValide = null

// Achat
const produit = ref(null)
let isNewTitreSelected = ref(false)
const catalogue = ref([])
const carteVide = ref(null)

const rechargementBloque = ref(false)

const titreList = useTemplateRef('titre-list')

const route = useRoute()
const router = useRouter()

const token = ref(null)
const tokenValide = ref(false)

onMounted(() => {
  console.log('On mounted executé')
  console.log(props.modeDepositaire)
  if (route.params.rechargementId) {
    numeroRechargement.value = route.params.rechargementId
    verifierRechargement()
  }

  if (props.modeDepositaire) {
    token.value = localStorage.getItem('token')

    if (token.value) {
      verifyToken(token.value)
    } else {
      console.error('Aucun token fourni pour le rechargement.')
      tokenValide.value = false
      router.push({ name: 'login' })
    }
  }
})

async function verifyToken(token) {
  try {
    const response = await axios.get(`utilisateur/token/verify/${token}`)
    console.log('Token valide')
    tokenValide.value = true
  } catch (err) {
    console.error('Token invalide ou expiré', err)
    tokenValide.value = false
    loadingErreur.value = true
  }
}

function toggleCollapse() {
  isAchatCollapsed.value = !isAchatCollapsed.value
  isPaiementCollapsed.value = !isPaiementCollapsed.value
}

function valideStepOne(e) {
  if (!titreSelectionne.value && !produit.value) {
    e.preventDefault()
    return
  }

  if (isNewTitreSelected.value) {
    if (props.modeDepositaire) {
      achatDepositaire(e)
    } else {
      achat(e)
    }
  } else {
    if (props.modeDepositaire) {
      rechargementDepositaire(e)
    } else {
      rechargement(e)
    }
  }
}

// Rechargement
function rechargement(e) {
  e.preventDefault()
  if (loading.value) {
    return
  }
  loading.value = true

  axios
    .post('/commandes/prepareRechargement', {
      codeProduit: titreSelectionne.value.codeProduit,
      email: email.value,
      titreARecharger: titreSelectionne.value.titreId,
      numeroRechargement: numeroRechargementValide,
      needFacture: needFacture.value,
      justificatifProduitFile: justificatifProduitFile.value,
      reductionId: titreSelectionne.value.reductionId,
    })
    .then(
      succes => {
        console.log('succes', succes.data)
        paymentToken.value = succes.data.token
        // On récupère le token et on initialise payline
        loadPayline(succes.data.production).then(() => {
          toggleCollapse()
          loading.value = false
        })
      },
      erreur => {
        loadingTitre.value = false
        console.error('ERREUR', erreur.body)
        erreurMessage.value =
          erreur?.response?.data ||
          'Erreur lors de la préparation de la commande.'
      },
    )
}

// Rechargement via un dépositaire
function rechargementDepositaire(e) {
  e.preventDefault()
  if (loading.value) {
    return
  }
  loading.value = true

  axios
    .post(`/depositaire/recharger/${token.value}`, {
      codeProduit: titreSelectionne.value.codeProduit,
      email: email.value,
      titreARecharger: titreSelectionne.value.titreId,
      numeroRechargement: numeroRechargementValide,
      reductionId: titreSelectionne.value.reductionId,
    })
    .then(
      succes => {
        console.log('succes', succes.data)
        if (props.modeDepositaire) {
          router.push({
            name: 'succesRechargementDepositaire',
            query: {
              numeroCommande: succes.data.numeroCommande,
            },
          })
        } else {
          router.push({
            name: 'succesRechargement',
            query: {
              numeroCommande: succes.data.numeroCommande,
            },
          })
        }
        /**router.push({
          name: 'succesRechargement',
          query: {
            numeroCommande: succes.data.numeroCommande,
          },
        })**/
      },
      erreur => {
        loadingTitre.value = false
        console.error('ERREUR', erreur.body)
        erreurMessage.value =
          erreur?.response?.data ||
          'Erreur lors de la préparation de la commande.'
      },
    )
}

// Achat depuis un dépositaire
function achatDepositaire(e) {
  e.preventDefault()
  if (loading.value === true) {
    return
  }
  loading.value = true

  axios
    .post(`/depositaire/vendre/${token.value}`, {
      codeProduit: produit.value.codeProduit,
      email: email.value,
      numeroRechargement: numeroRechargementValide,
      needFacture: false,
      reductionId: produit.value.reductionId,
    })
    .then(
      succes => {
        router.push({
          name: 'succesAchatNFC',
          query: {
            numeroCommande: succes.data.numeroCommande,
          },
        })
      },
      erreur => {
        console.error('ERREUR', erreur.body)
        console.error('Erreur lors de l’achat', erreur)
        erreurMessage.value =
          erreur?.response?.data ||
          'Erreur lors de la préparation de la commande.'
      },
    )
    .finally(() => {
      loading.value = false
    })
}

function deselectionnerTitre() {
  isNewTitreSelected.value = true
  titreSelectionne.value = ''
}

// Achat
function achat(e) {
  e.preventDefault()
  if (loading.value === true) {
    return
  }
  loading.value = true

  axios
    .post('/commandes/prepareVente', {
      codeProduit: produit.value.codeProduit,
      email: email.value,
      numeroRechargement: numeroRechargementValide,
      needFacture: needFacture.value,
      justificatifProduitFile: justificatifProduitFile.value,
      reductionId: produit.value.reductionId,
    })
    .then(
      succes => {
        paymentToken.value = succes.data.token
        // On récupère le token et on initialise payline
        loadPayline(succes.data.production).then(() => {
          toggleCollapse()
        })
      },
      erreur => {
        console.error('ERREUR', erreur.body)
        console.error('Erreur lors de l’achat', erreur)
        erreurMessage.value =
          erreur?.response?.data ||
          'Erreur lors de la préparation de la commande.'
      },
    )
    .finally(() => {
      loading.value = false
    })
}

function selectionnerTitre() {
  produit.value = null
  isNewTitreSelected.value = false
}

function detailValiditeeEnCours(titre) {
  if (typeof titre.nbTrajets === 'number' && titre.nbTrajets > 0) {
    return ' solde : ' + titre.nbTrajets + ' trajet(s)'
  } else if (typeof titre.nbTrajets === 'number' && titre.nbTrajets === 0) {
    return ' solde : épuisé'
  } else if (
    typeof titre.finValiditee === 'string' &&
    titre.finValiditee.length > 0
  ) {
    return ' expire le : ' + toFrenchDate(titre.finValiditee)
  }
  return ''
}

function detailFutureSolde(titre) {
  if (
    typeof titre.nouveauNbTrajets === 'number' &&
    titre.nouveauNbTrajets > 0
  ) {
    return (
      ' Solde après rechargement : ' + titre.nouveauNbTrajets + ' trajet(s)'
    )
  }
  return ''
}

function resetSelections() {
  titreSelectionne.value = ''
  produit.value = null
  isNewTitreSelected.value = false
  justificatifProduitFile.value = null
  justificatifValidationMessage.value = ''
  paymentToken.value = undefined
  suiteForm.value = false
}

// Commun
function verifierRechargement() {
  resetSelections()

  if (numeroRechargement.value === null || numeroRechargement.value === '') {
    erreurMessage.value = 'Un numéro de carte est obligatoire.'
    return
  }

  // On vire les espaces dans la saisie, on est sympa
  numeroRechargement.value = numeroRechargement.value.replace(/\s/g, '')

  // 1 - obtenir le(s) titre(s) correspondant au numéro de rechargement
  erreurMessage.value = null
  loadingTitre.value = true
  suiteForm.value = false
  titres.value = []
  carteVide.value = null
  numeroRechargementValide = numeroRechargement.value

  const titresPromise = axios.get('/titres', {
    params: {
      numeroRechargement: numeroRechargement.value,
      dateRechargement: null,
    },
  })

  const cataloguePromise = axios.get(
    'produits/produit-rechargement/' + numeroRechargement.value,
    {
      params: {
        seeReduction: true,
        showReductionLibelle: true,
      },
    },
  )

  Promise.allSettled([titresPromise, cataloguePromise])
    .then(results => {
      const titresResult = results[0]
      const catalogueResult = results[1]

      // Gestion des titres
      if (titresResult.status === 'fulfilled') {
        const succes = titresResult.value

        if (succes.data === 'CARTE_NON_CONNUE') {
          carteVide.value = true
        } else {
          titres.value = succes.data
          carteVide.value = false
        }
        suiteForm.value = true

        setTimeout(() => {
          titreList.value.scrollIntoView({ behavior: 'smooth' })
        }, 500)
      } else {
        const erreur = titresResult.reason
        const message = erreur.response?.data
        rechargementBloque.value = false
        if (erreur.status === 400) {
          //bloque seulement le rechargement
          erreurMessage.value = message
          rechargementBloque.value = true

          // mais on autorise la suite pour l'achat
          titres.value = []
          carteVide.value = true
          suiteForm.value = true
        } else {
          erreurMessage.value = erreur.response?.data ?? 'Titre introuvable.'
        }
      }

      // Gestion du catalogue (ne doit pas écraser l'erreur des titres si elle est plus pertinente)
      if (catalogueResult.status === 'fulfilled') {
        const succes = catalogueResult.value
        catalogue.value = succes.data
        catalogue.value.sort((one, two) => (one.libelle > two.libelle ? 1 : -1))
      } else {
        const erreur = catalogueResult.reason
        // On ne met à jour l'erreur du catalogue que si aucune erreur n'a été positionnée par l'appel titres
        // ou si l'erreur titres n'est pas "Carte non connue" (via carteVide)
        if (!erreurMessage.value && !carteVide.value) {
          if (erreur.data === undefined) {
            erreurMessage.value = 'Erreur lors de la récuperation du catalogue.'
          } else {
            if (erreur.data.status === 500) {
              erreurMessage.value =
                'Erreur lors de la récuperation du catalogue.'
            } else {
              console.error('ERREUR', erreur.body)
              erreurMessage.value = erreur.response.data
            }
          }
        }
      }
    })
    .finally(() => {
      loadingTitre.value = false
    })
}

function toCurrency(value) {
  if (typeof value !== 'number') {
    return value
  }
  const formatter = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  })
  return formatter.format(value)
}

function toFrenchDate(value) {
  if (value == null || value === '') {
    return ''
  }

  return new Intl.DateTimeFormat('fr-FR').format(new Date(value))
}
</script>

<template>
  <!-- Bloc accès refusé si modeAgence et token invalide -->
  <div
    v-if="
      props.modeDepositaire && tokenValide === false && loadingErreur === true
    "
    class="my-5"
  >
    <div
      class="alert alert-danger d-flex align-items-center p-4 mx-3 mx-md-5"
      role="alert"
      style="font-size: 1.1rem"
    >
      <i
        class="bi bi-shield-x me-3"
        style="font-size: 2rem"
        aria-hidden="true"
      ></i>
      <div>
        <strong>Accès refusé :</strong> Vous n’êtes pas autorisé à accéder à
        cette page.<br />
        Le lien que vous avez utilisé n’est plus valide ou votre session a
        expiré.
      </div>
    </div>

    <div class="text-center mt-4">
      <router-link :to="{ name: 'login' }"> Retour à la connexion </router-link>
    </div>
  </div>

  <section
    :class="{ collapse: !isPaiementCollapsed, show: isPaiementCollapsed }"
    aria-labelledby="titre-rechargement"
    class="overflow-auto"
    v-if="!props.modeDepositaire || tokenValide"
  >
    <div id="rechargement">
      <form @submit="valideStepOne">
        <div class="achat container">
          <h1 id="titre-rechargement">
            Rechargement de votre titre de transport
          </h1>
          <h2>Indiquez le numéro présent sur votre carte</h2>

          <div class="form_recharge">
            <div class="carte_recharge card">
              <div class="card-body">
                <div
                  class="num_rechargement text-center row m-2 d-block mx-auto"
                >
                  <img
                    src="@/assets/rechargement-cartes.jpg"
                    alt=""
                    aria-hidden="true"
                  />
                </div>

                <div class="div_icon_input row rc-form">
                  <div class="col-sm-1 d-none d-sm-block">
                    <i class="fas fa-ticket-alt" aria-hidden="true"></i>
                  </div>
                  <div class="col-sm-11 col-xs-10">
                    <label for="numRechargement-input" class="visually-hidden"
                      >Entrez le numéro de votre carte pour la recharger</label
                    >
                    <input
                      type="text"
                      id="numRechargement-input"
                      v-model="numeroRechargement"
                      placeholder="ex: 12345"
                      class="input_number form-control"
                      :aria-invalid="rechargementBloque ? 'true' : 'false'"
                      aria-describedby="message-rechargement"
                      required
                    />
                  </div>
                </div>

                <div id="message-rechargement" aria-live="assertive">
                  <p
                    v-if="!rechargementBloque && erreurMessage"
                    class="fs-6 text-center text-danger my-5"
                  >
                    {{ erreurMessage }}
                  </p>
                  <!--<p v-if="rechargementBloque" class="text-warning text-center">{{ erreurMessage }}</p>-->
                </div>

                <div class="text-center mt-3">
                  <button
                    type="button"
                    @click="verifierRechargement"
                    class="bouton_valid btn btn-lg"
                  >
                    Vérifier
                    <i class="fas fa-arrow-right" aria-hidden="true"></i>
                  </button>
                </div>

                <p v-if="carteVide" class="text-center mt-3">
                  Remarque : Merci de bien vérifier le numéro de carte que vous
                  venez d'inscrire ci-dessus
                </p>

                <div
                  v-if="loadingTitre"
                  class="div_loader_titre text-center my-3"
                >
                  <div
                    class="loaderTitre"
                    role="status"
                    aria-label="Chargement en cours"
                  ></div>
                </div>

                <p v-if="titres.length > 0 || carteVide !== null">
                  Choisissez le produit que vous désirez recharger / acheter :
                </p>

                <div class="container choix_titre" ref="titre-list">
                  <div class="row gy-1">
                    <div
                      v-bind:key="titre.titreId"
                      v-if="titres.length > 0 && carteVide !== null"
                      v-for="titre in titres"
                      class="col-md-6 col-12 align-items-stretch"
                    >
                      <div class="div_nature h-100">
                        <label
                          :for="titre.titreId"
                          class="text-center w-100 h-100 d-flex flex-column justify-content-center align-items-center"
                        >
                          <input
                            v-on:change="selectionnerTitre"
                            v-model="titreSelectionne"
                            type="radio"
                            name="nature"
                            class="btn nature"
                            :id="titre.titreId"
                            :value="titre"
                            :disabled="
                              rechargementBloque ||
                              paymentToken !== undefined ||
                              titre.currentCommandeRechargementExists
                            "
                            required
                          />
                          <!-- Titre et validité -->
                          {{ titre.libelleProduit }}
                          <i>( {{ detailValiditeeEnCours(titre) }} )</i>
                          <br />

                          <!-- Coût et expiration -->
                          <span
                            v-if="
                              titre.tarif !== null &&
                              !titre.currentCommandeRechargementExists
                            "
                            >Coût du rechargement :
                            {{ toCurrency(titre.tarif) }}</span
                          >
                          <br />
                          <i
                            v-if="
                              titreSelectionne !== '' &&
                              titreSelectionne === titre &&
                              !titre.currentCommandeRechargementExists &&
                              titreSelectionne.nouvelleFinValiditee === null
                            "
                            >( {{ detailFutureSolde(titre) }} )</i
                          >
                          <div
                            v-else-if="titre.currentCommandeRechargementExists"
                            class="text-danger font-weight-bold"
                          >
                            Rechargement en cours, vous ne pouvez recharger ce
                            titre pour le moment.
                          </div>
                        </label>
                      </div>
                      <!-- Option pour un nouveau titre -->
                    </div>
                    <div
                      key="newTitre"
                      class="col-md-6 col-12 align-items-stretch"
                    >
                      <div
                        class="div_nature h-100"
                        v-if="titres.length > 0 || carteVide !== null"
                      >
                        <label
                          class="text-center h-100 w-100 d-flex flex-column justify-content-center align-items-center"
                        >
                          <input
                            type="radio"
                            name="nature"
                            class="btn nature h-100 w-100"
                            id="newTitre"
                            :disabled="catalogue.length === 0"
                            v-on:change="deselectionnerTitre"
                            required
                          />
                          <span class="h6">Achat d'un nouveau titre</span>
                          <br />
                          <div
                            v-if="catalogue.length === 0 || carteVide === null"
                            class="text-danger font-weight-bold"
                          >
                            Il n'est pas possible d'ajouter un titre à cette
                            carte.
                          </div>
                          <div class="row w-100" v-else-if="isNewTitreSelected">
                            <div class="col-12">
                              <select
                                v-model="produit"
                                class="form-control my-2"
                                required
                              >
                                <option disabled :value="null">
                                  Veuillez sélectionner un produit
                                </option>
                                <option
                                  v-for="item in catalogue"
                                  :key="item.id"
                                  :value="item"
                                >
                                  {{ item.libelle }} ({{
                                    toCurrency(item.tarif)
                                  }})
                                </option>
                              </select>
                            </div>
                          </div>
                          <p v-else>
                            Si vous souhaitez ajouter un titre à votre carte,
                            cliquez ici.
                          </p>

                          <span v-if="produit"
                            >Coût de l'achat : {{ toCurrency(produit.tarif)
                            }}<br
                          /></span>
                          <br />
                          <i v-if="produit && produit.type === 'Trajet'">
                            Solde après achat : {{ produit.uniter }} trajet(s)
                          </i>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="
                ((suiteForm && titreSelectionne !== '') ||
                  (isNewTitreSelected && produit)) &&
                !modeDepositaire
              "
              class="mt-4"
            >
              <p class="info_mail">
                Afin de pouvoir finaliser votre achat, merci de renseigner votre
                adresse email :
              </p>

              <div class="form-check mb-3">
                <input
                  class="form-check-input"
                  v-model="needFacture"
                  type="checkbox"
                  id="checkbox-facture"
                />
                <label class="form-check-label" for="checkbox-facture">
                  Je souhaite avoir une facture.
                </label>
              </div>

              <div class="div_icon_input row rc-form mb-4">
                <div class="col-12 col-sm-1 text-center d-none d-sm-block">
                  <i class="fas fa-envelope" aria-hidden="true"></i>
                </div>
                <div class="col-sm-11 col-xs-10">
                  <label for="email-input" class="visually-hidden"
                    >Entrez votre adresse E-mail</label
                  >
                  <input
                    v-model="email"
                    type="email"
                    class="form-control"
                    id="email-input"
                    placeholder="Adresse E-mail"
                    required
                  />
                </div>
              </div>
              <div class="text-center">
                <button :disabled="!email" class="bouton_valid btn btn-lg">
                  VALIDER
                  <i class="fas fa-arrow-right" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div
              class="mt-4"
              v-else-if="
                ((suiteForm && titreSelectionne !== '') ||
                  (isNewTitreSelected && produit)) &&
                modeDepositaire
              "
            >
              <button class="bouton_valid btn btn-lg">
                VALIDER
                <i class="fas fa-arrow-right" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>

  <section
    class="paiement container mt-4"
    :class="{ collapse: isPaiementCollapsed, show: !isPaiementCollapsed }"
    aria-labelledby="titre-paiement"
  >
    <h1 id="titre-paiement">Finalisation de votre achat - Paiement</h1>
    <h2>Récapitulatif de votre achat</h2>

    <div class="carte_recap card mb-4">
      <div class="card-body text-center">
        <p
          v-if="titreSelectionne !== '' && titreSelectionne.tarif !== null"
          class="card-text mb-0"
        >
          Produit : {{ titreSelectionne.libelleProduit }}<br />
          Montant : {{ toCurrency(titreSelectionne.tarif) }}
        </p>
        <p
          v-if="produit !== null && produit.tarif !== null"
          class="card-text mb-0"
        >
          Produit : {{ produit.libelle }}<br />
          Montant : {{ toCurrency(produit.tarif) }}
        </p>
      </div>
    </div>

    <div
      id="PaylineWidget"
      :data-token="paymentToken"
      data-template="column"
      data-auto-init="true"
      data-embeddedredirectionallowed="false"
      data-event-didshowstate="handleWidgetDidShowState"
      data-event-finalstatehasbeenreached="handleFinalStateReached"
    ></div>
  </section>
</template>

<style scoped lang="scss">
@import '@/assets/main';

p {
  font-weight: bold;
}

.md-steppers .md-steppers-navigation {
  display: none;
}

.div_nature {
  display: flex;
  flex-direction: column;
  background-color: var(--color-bleu-luneo);
  color: white;
  padding: 1em;

  input[type='radio'] {
    position: absolute;
    left: -9999px;
    //display: none;
  }

  label {
    cursor: pointer;
  }

  &:has(input[type='radio']:checked) {
    background-color: var(--color-bleu-2);
    animation: borderAnimation 1s infinite linear;
    border: 4px dashed gray;
    box-shadow: 0 0 5px #5d5c5c;
  }

  &:has(input[type='radio']:checked) * {
    background-color: var(--color-bleu-2);
    color: white;
    cursor: default;
  }

  select {
    color: black !important;
    background: white !important;
  }

  input[type='date'] {
    color: black !important;
    background: white !important;
  }

  &:has(input[type='radio']:disabled) {
    background-color: lightgray !important;
    color: #999;
  }

  &:has(input[type='radio']:disabled) * {
    background-color: lightgray !important;
    color: #999;
  }

  &:hover {
    background-color: var(--color-bleu-2);
  }

  @keyframes borderAnimation {
    0% {
      border-color: var(--color-bleu-luneo);
    }
    50% {
      border-color: var(--color-bleu-2);
    }
    100% {
      border-color: var(--color-bleu-luneo);
    }
  }
}

.form_recharge {
  .carte_recharge {
    border: none !important;

    .num_rechargement {
      p {
        font-weight: bold;
      }

      img {
        max-width: 100%;
        height: auto;
        width: 45%;
      }
    }

    .info_mail {
      margin-top: 3rem;
    }

    .div_icon_input {
      max-width: 100%;
      overflow: hidden;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      margin-bottom: 1rem;
    }
  }

  @media (max-width: 576px) {
    img {
      display: none;
    }
  }
}

.paiement {
  h1 {
    text-align: center;
  }

  .carte_recap {
    h6 {
      color: var(--color-bleu-2);
    }
  }
}

.div_loader_titre {
  text-align: center;

  .loaderTitre {
    width: 3rem;
    height: 3rem;
    color: var(--color-bleu-luneo);
  }
}

.radio-toolbar {
  width: 100%;

  input[type='radio'] {
    opacity: 0;
    position: inherit;
    width: 0;
  }

  label {
    display: flex;
    background-color: white;
    padding: 10px 20px;
    font-family: sans-serif, Arial;
    font-size: 16px;
    border: 1px solid #ced4da;
    border-radius: 4px;

    p {
      margin: auto;
    }
  }

  input[type='radio']:checked + label {
    background-color: var(--color-bleu-luneo);
    color: white;
  }

  input[type='radio']:focus + label {
    border: 2px dashed #444;
  }
}

label {
  margin: auto;
  text-align: center;
}

.nature {
  border-color: #ced4da;
  color: var(--color-bleu-2);
}

span {
  margin: auto;
}

.bouton_valid {
  display: block;
  margin: 1rem auto;
  @include boutons;
}

.bouton_valid:hover,
.bouton_valid:focus {
  @include boutons_hover;
}
</style>
